export const nullAddress = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE';
export const wethAddress = {
    1: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    11155111: '0xfFf9976782d46CC05630D1f6eBAb18b2324d6B14',
};
export const usdtAddress = {
    1: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    11155111: '0x63b26b83c6f38433B2b6a7214fC2c569a4F4069A',
};
export const wrapperTokenAddress = {
    1: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    10: '0x4200000000000000000000000000000000000006',
    56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    137: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270',
    324: '0x5AEa5775959fBC2557Cc8789bC1bf90A239D9a91',
    8453: '0x4200000000000000000000000000000000000006',
    42161: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
    11155111: '0xfFf9976782d46CC05630D1f6eBAb18b2324d6B14',
};
export const allowanceTargetAddress = {
    1: '0xFb4aA7E6299502b36490cD4f8005481E69B0bEE0',
    10: '0xFb4aA7E6299502b36490cD4f8005481E69B0bEE0',
    56: '0xFb4aA7E6299502b36490cD4f8005481E69B0bEE0',
    137: '0xFb4aA7E6299502b36490cD4f8005481E69B0bEE0',
    324: '0xd2a6e115f12Eefc3062Aba65bDf0f2EA5c3d08CB',
    8453: '0xFb4aA7E6299502b36490cD4f8005481E69B0bEE0',
    42161: '0xFb4aA7E6299502b36490cD4f8005481E69B0bEE0',
    11155111: '0xFb4aA7E6299502b36490cD4f8005481E69B0bEE0',
};
export const genericSwapAddress = {
    1: '0xa7e96Bf2735BD33750Bb504C3Cc63e3770668dd4',
    10: '0xac4F3817a726016fC8254119FC48bE838a21f17F',
    56: '0xac4F3817a726016fC8254119FC48bE838a21f17F',
    137: '0xac4F3817a726016fC8254119FC48bE838a21f17F',
    324: '0xC63c379Ae456af9C73Bf81A7D745fAF1d9e180e0',
    8453: '0xac4F3817a726016fC8254119FC48bE838a21f17F',
    42161: '0xac4F3817a726016fC8254119FC48bE838a21f17F',
    11155111: '0xac4F3817a726016fC8254119FC48bE838a21f17F',
};
export const permit2Address = {
    1: '0x000000000022d473030f116ddee9f6b43ac78ba3',
    10: '0x000000000022d473030f116ddee9f6b43ac78ba3',
    56: '0x000000000022d473030f116ddee9f6b43ac78ba3',
    137: '0x000000000022d473030f116ddee9f6b43ac78ba3',
    324: '0x0000000000225e31d15943971f47ad3022f714fa',
    8453: '0x000000000022d473030f116ddee9f6b43ac78ba3',
    42161: '0x000000000022d473030f116ddee9f6b43ac78ba3',
    11155111: '0x000000000022d473030f116ddee9f6b43ac78ba3',
};
export const strategyAddress = {
    1: '0x0E67fD506Db5C6199C5D2b2b54380DEB414E2431',
    10: '0x4D5ECA271ca6668804F02cedf3C423b824c3CfbC',
    56: '0x4D5ECA271ca6668804F02cedf3C423b824c3CfbC',
    137: '0x4D5ECA271ca6668804F02cedf3C423b824c3CfbC',
    324: '0x717C780F8cbD6b5744e0A8b9c88bF36081B1C8b4',
    8453: '0x4D5ECA271ca6668804F02cedf3C423b824c3CfbC',
    42161: '0x4D5ECA271ca6668804F02cedf3C423b824c3CfbC',
    11155111: '0x4D5ECA271ca6668804F02cedf3C423b824c3CfbC',
};
export const FEE_RECIPIENT_ADDRESS = '0x4529F88C9EDAE85560a5014A3A243996e162B3C9';
//# sourceMappingURL=addresses.js.map